import PostSubmissionContent from "./PostSubmissionContent/PostSubmissionContent";

export const PostSubmissionCard = () => {
  return <PostSubmissionContent />;
};
